export enum CategoryField {
    VEH = "vh",
    MOA = "mo",
    MAT = "pr"
}

export type FieldObject = {
    i18n: string;
    key: string;
    label?: string;
    premium?: boolean;
};

export type CategoryObject = {
    field: CategoryField;
    i18n: string;
    id: number;
    name?: string;
    premium?: boolean;
};
